(() => {
  if (window.MusBasketDrawerV22 || !window.fetch || !window.HTMLDialogElement) return;
  const root = document.querySelector('[data-mus-basket]');
  if (!root) return;
  const dialog = root.querySelector('dialog');
  const content = root.querySelector('[data-mus-basket-content]');
  const list = root.querySelector('[data-mus-basket-list]');
  const tpl = root.querySelector('[data-mus-basket-item-template]');
  const rewards=root.querySelector('[data-mus-rewards]');
  const giftIds=rewards?(rewards.getAttribute('data-gift-ids')||'').split(',').map(Number).filter(Boolean):[];
  const giftSet=new Set(giftIds),giftTag='mus-elaiza-250-gift';
  const giftLockKey='mus-elaiza-gift-discount-mismatch';
  const tradeRate = Number(root.dataset.tradeRate) || 0;
  const tradeTitle = root.dataset.tradeTitle || 'Trade Exclusive';
  let busy = false, synced = false, opener = null;
  const navSelector = '[data-mus-open-cart],a[href]';
  const formSelector = '.mus-product-form,.mus-quick-add-form,.mus-new-quick-add-form,.mus-premium-card__form,form[action*="/cart/add"]';
  const sameUrl = value => { try { const u = new URL(value, location.origin); return u.origin === location.origin ? u : null; } catch (_) { return null; } };
  const money = cents => { try { return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency:root.dataset.currency || 'GBP'}).format(cents/100); } catch (_) { return '£' + (cents/100).toFixed(2); } };
  const say = (text='') => { root.querySelector('[data-mus-basket-status]').textContent = text; };
  const showError = (text='') => { root.querySelector('[data-mus-basket-error-text]').textContent=text; root.querySelector('[data-mus-basket-error]').hidden=!text; };
  const addText = (parent,text,cls='mus-basket__meta') => { const p=document.createElement('p');p.className=cls;p.textContent=text;parent.appendChild(p); };
  const allocs = item => Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations.map(d=>({title:d.discount_application?.title||'',amount:Number(d.amount)||0})) : (Array.isArray(item.discounts)?item.discounts.map(d=>({title:d.title||'',amount:Number(d.amount)||0})):[]);
  const normalise = v => String(v||'').trim().toLowerCase();
  const isElaizaGiftDiscountTitle = title => normalise(title).includes('free elaiza 3-piece set');
  const isTradeTitle = title => { const a=normalise(title),b=normalise(tradeTitle); return tradeRate>0 && !!b && (a===b || a===b+' discount' || a.startsWith(b+' - ') || a==='wholesale pricing' || a==='wholesale pricing discount'); };
  const tradeLabel = () => tradeTitle;

  function setBusy(value){busy=value;content.setAttribute('aria-busy',String(value));content.querySelectorAll('[data-mus-basket-adjust],[data-mus-basket-quantity],[data-mus-basket-remove],[data-mus-upsell-add]').forEach(el=>el.disabled=value||!synced);root.querySelector('[data-mus-basket-checkout]').disabled=value||!synced||Number(content.dataset.count)<1;root.querySelector('[data-mus-basket-retry]').disabled=value;}
  function setExpanded(value){document.querySelectorAll('[data-mus-open-cart]').forEach(button=>button.setAttribute('aria-expanded',String(value)));}
  function open(source){opener=source||document.activeElement;if(!dialog.open){document.dispatchEvent(new CustomEvent('mus:cart-opened'));dialog.showModal();document.documentElement.classList.add('mus-basket-open');setExpanded(true);dialog.querySelector('[data-mus-basket-close]').focus({preventScroll:true});}}
  function close(){if(dialog.open)dialog.close();}
  dialog.addEventListener('close',()=>{document.documentElement.classList.remove('mus-basket-open');setExpanded(false);if(opener?.isConnected)opener.focus({preventScroll:true});});

  async function request(path,options={}){const u=sameUrl(path);if(!u)throw new Error(root.dataset.error);const res=await fetch(u.pathname+u.search,{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json',...(options.headers||{})},...options});let data={};try{data=await res.json();}catch(_){throw new Error(root.dataset.error);}if(!res.ok||Number(data.status)>=400)throw new Error(data.description||data.message||root.dataset.error);return data;}
  const readCart=()=>request(root.dataset.cartUrl+'.js');

  function priceModel(cart){
    const nativeDiscount = Number(cart.total_discount)>0 || (cart.discount_codes||[]).length>0 || (cart.cart_level_discount_applications||[]).some(d=>Number(d.total_allocated_amount)>0) || cart.items.some(item=>Number(item.original_line_price)>Number(item.final_line_price ?? item.line_price) || allocs(item).some(d=>d.amount>0));
    const eligible = tradeRate>0 && tradeRate<100 && !nativeDiscount;
    const lines=cart.items.map(item=>{const base=Number(item.final_line_price ?? item.line_price)||0;return eligible && !item.gift_card && !item.selling_plan_allocation && !(item.item_components||[]).length ? Math.round(base*(100-tradeRate)/100) : base;});
    const raw=cart.items.reduce((s,item)=>s+(Number(item.final_line_price ?? item.line_price)||0),0);
    const calc=lines.reduce((s,v)=>s+v,0);
    return {estimated:eligible&&calc<raw,lines,savings:Math.max(0,raw-calc),total:eligible ? Math.max(0,Number(cart.total_price)-Math.max(0,raw-calc)) : Number(cart.total_price)};
  }

  function discountRow(parent,title,cents,isTrade=false){if(!(cents>0)||isElaizaGiftDiscountTitle(title))return;const row=document.createElement('div');row.className='mus-basket__discount'+(isTrade?' is-trade':'');const l=document.createElement('span');l.textContent=title;const v=document.createElement('span');v.textContent='−'+money(cents);row.append(l,v);parent.appendChild(row);}
  function syncBadge(count){root.querySelector('[data-mus-basket-count]').textContent=String(count);document.querySelectorAll('.mus-cart-icon-wrap,.mus-mobile-cart-link').forEach(container=>{let badge=container.querySelector('em');if(count>0){if(!badge){badge=document.createElement('em');container.appendChild(badge);}badge.textContent=String(count);}else badge?.remove();});}

  let upsellRequestId = 0;

  function renderUpsellProducts(products, cart) {
    const wrap = root.querySelector('[data-mus-basket-upsell]');
    const holder = root.querySelector('[data-mus-basket-upsell-list]');
    if (!wrap || !holder) return;

    const inCart = new Set((cart.items || []).map(item => String(item.product_id)));
    const filtered = (products || []).filter(product => {
      return product && product.available && !inCart.has(String(product.id));
    }).slice(0, 2);

    if (!filtered.length) {
      holder.replaceChildren();
      wrap.hidden = true;
      return;
    }

    const fragment = document.createDocumentFragment();

    filtered.forEach(product => {
      const variant = (product.variants || []).find(v => v.available) || (product.variants || [])[0];
      if (!variant || !variant.id) return;

      const card = document.createElement('article');
      card.className = 'mus-basket__upsell-item';

      const link = document.createElement('a');
      link.className = 'mus-basket__upsell-image';
      link.href = product.url || '#';

      const image = product.featured_image?.url || product.featured_image || (product.images || [])[0];
      if (image) {
        const img = document.createElement('img');
        img.src = image;
        img.alt = product.title || '';
        img.loading = 'lazy';
        link.appendChild(img);
      }

      const copy = document.createElement('div');
      copy.className = 'mus-basket__upsell-copy';

      const title = document.createElement('a');
      title.className = 'mus-basket__upsell-title';
      title.href = product.url || '#';
      title.textContent = product.title || '';

      const shownPrice = tradeRate > 0
        ? Math.round(Number(variant.price || product.price || 0) * (100 - tradeRate) / 100)
        : Number(variant.price || product.price || 0);
      const price = document.createElement('strong');
      price.textContent = money(shownPrice);

      copy.append(title, price);

      const add = document.createElement('button');
      add.type = 'button';
      add.className = 'mus-basket__upsell-add';
      add.dataset.musUpsellAdd = '';
      add.dataset.variantId = String(variant.id);
      add.textContent = 'Add';

      card.append(link, copy, add);
      fragment.appendChild(card);
    });

    holder.replaceChildren(fragment);
    wrap.hidden = !holder.children.length;
  }

  async function updateUpsell(cart) {
    const wrap = root.querySelector('[data-mus-basket-upsell]');
    const holder = root.querySelector('[data-mus-basket-upsell-list]');
    if (!wrap || !holder) return;

    const requestId = ++upsellRequestId;

    if (!cart.items || !cart.items.length) {
      holder.replaceChildren();
      wrap.hidden = true;
      return;
    }

    const productId = cart.items[0].product_id;

    async function load(intent) {
      return request('/recommendations/products.json?product_id=' + encodeURIComponent(productId) + '&limit=6&intent=' + encodeURIComponent(intent));
    }

    try {
      let data = await load('complementary');
      let products = Array.isArray(data.products) ? data.products : [];

      if (!products.length) {
        data = await load('related');
        products = Array.isArray(data.products) ? data.products : [];
      }

      if (requestId !== upsellRequestId) return;
      renderUpsellProducts(products, cart);
    } catch (_) {
      if (requestId !== upsellRequestId) return;
      holder.replaceChildren();
      wrap.hidden = true;
    }
  }

  
  const giftLockRead=()=>{try{return sessionStorage.getItem(giftLockKey)||'';}catch(_){return '';}};
  const giftLockWrite=s=>{try{sessionStorage.setItem(giftLockKey,s);}catch(_){}};
  const giftLockClear=()=>{try{sessionStorage.removeItem(giftLockKey);}catch(_){}};
  const qualifyingSpend=cart=>(cart.items||[]).filter(i=>!giftSet.has(Number(i.variant_id))).reduce((n,i)=>n+Number(i.original_line_price||0),0);
  function giftSignature(cart){
    return (cart.items||[]).filter(i=>!giftSet.has(Number(i.variant_id))).map(i=>i.variant_id+':'+i.quantity).sort().join('|')+':'+
      (cart.cart_level_discount_applications||[]).map(i=>i.title||'').sort().join('|');
  }
  async function syncDrawerGifts(cart){
    if(!rewards||root.dataset.elaizaGiftSync!=='1'||giftIds.length!==3||rewards.getAttribute('data-gift-stock')!=='1')return cart;
    const qualified=qualifyingSpend(cart)>=25000;
    const marked=(cart.items||[]).filter(i=>giftSet.has(Number(i.variant_id))&&i.properties&&i.properties._mus_elaiza_gift===giftTag);
    const updates={};
    if(!qualified){giftLockClear();marked.forEach(i=>updates[i.key]=0);}
    else if(marked.some(i=>Number(i.final_line_price)>0)){
      giftLockWrite(giftSignature(cart));marked.forEach(i=>updates[i.key]=0);
    }else marked.forEach(i=>{if(Number(i.quantity)!==1)updates[i.key]=1;});
    if(Object.keys(updates).length){
      await request(root.dataset.cartUrl.replace(/\/$/,'')+'/update.js',{
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates})
      });
      return readCart();
    }
    if(!qualified||giftLockRead()===giftSignature(cart))return cart;
    const existing=new Set(marked.map(i=>Number(i.variant_id)));
    const missing=giftIds.filter(id=>!existing.has(id));
    if(!missing.length)return cart;
    await request(root.dataset.addUrl,{
      method:'POST',headers:{'Content-Type':'application/json'},
      body:JSON.stringify({items:missing.map(id=>({
        id,quantity:1,properties:{_mus_elaiza_gift:giftTag,Gift:'FREE Elaiza gift with £250+ order'}
      }))})
    });
    let updated=await readCart();
    const added=(updated.items||[]).filter(i=>giftSet.has(Number(i.variant_id))&&i.properties&&i.properties._mus_elaiza_gift===giftTag);
    if(added.some(i=>Number(i.final_line_price)>0)){
      giftLockWrite(giftSignature(updated));
      const remove={};added.forEach(i=>remove[i.key]=0);
      await request(root.dataset.cartUrl.replace(/\/$/,'')+'/update.js',{
        method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:remove})
      });
      updated=await readCart();
    }else giftLockClear();
    return updated;
  }
  function renderRewards(cart){
    if(!rewards)return;
    const qualifying=qualifyingSpend(cart),total=Number(cart.total_price)||0;
    const shippingReached=total>=7500,giftReached=qualifying>=25000;
    const marked=new Set((cart.items||[]).filter(i=>giftSet.has(Number(i.variant_id))
      &&i.properties&&i.properties._mus_elaiza_gift===giftTag
      &&Number(i.final_line_price)===0&&Number(i.quantity)===1).map(i=>Number(i.variant_id)));
    const verified=giftIds.length===3&&giftIds.every(id=>marked.has(id));
    const pct=giftReached?100:(shippingReached?Math.min(100,30+Math.max(0,qualifying-7500)/17500*70):Math.min(30,total/7500*30));
    const h=rewards.querySelector('[data-mus-rewards-headline]');
    const f=rewards.querySelector('[data-mus-rewards-fill]');
    const p=rewards.querySelector('[role="progressbar"]');
    const sh=rewards.querySelector('[data-mus-rewards-ship-mark]');
    const gi=rewards.querySelector('[data-mus-rewards-gift-mark]');
    if(h)h.textContent=giftReached?(verified?'Both rewards unlocked':'£250 gift threshold reached'):
      shippingReached?'Free shipping unlocked':
      money(7500-total)+' to free shipping';
    const sub=rewards.querySelector('[data-mus-rewards-subheadline]');
    if(sub){
      const unavailable=rewards.getAttribute('data-gift-stock')!=='1';
      const blocked=giftReached&&giftLockRead()===giftSignature(cart);
      const detail=verified?'':giftReached?
        (unavailable?'The complete Elaiza gift set is currently out of stock.':
          blocked?'The free gift discount cannot be combined with the discounts in your basket.':
          'Checking that your 3 Elaiza gifts are free.'):
        shippingReached?'Spend '+money(25000-qualifying)+' more to unlock 3 free Elaiza gifts.':
        'Reach £75 for free shipping, then £250 for your gift set.';
      sub.textContent=detail;
      sub.hidden=!detail;
    }
    if(f)f.style.width=Math.max(0,pct).toFixed(2)+'%';
    if(p)p.setAttribute('aria-valuenow',String(Math.round(Math.max(0,pct))));
    if(sh)sh.classList.toggle('is-achieved',shippingReached);
    if(gi)gi.classList.toggle('is-achieved',giftReached);
  }

  function render(cart){
    if(!cart||!Array.isArray(cart.items)||!Number.isSafeInteger(cart.item_count)||!Number.isFinite(Number(cart.total_price)))throw new Error(root.dataset.refreshError);
    root.dataset.currency=cart.currency||root.dataset.currency;
    const model=priceModel(cart),frag=document.createDocumentFragment(),summaryDiscounts=root.querySelector('[data-mus-basket-discounts]');summaryDiscounts.replaceChildren();
    const totals=new Map();
    cart.items.forEach((item,index)=>{
      const row=tpl.content.firstElementChild.cloneNode(true),title=item.product_title||item.title||'';row.dataset.musBasketKey=item.key;row.dataset.musBasketLine=String(index+1);
      const titleLink=row.querySelector('[data-item-title]');titleLink.textContent=title;if(item.url){const u=sameUrl(item.url);if(u){titleLink.href=u.href;row.querySelector('[data-item-image-link]').href=u.href;}}
      const src=item.featured_image?.url||item.image;if(src){try{const u=new URL(src,location.origin);const img=row.querySelector('img');img.src=u.href;img.hidden=false;}catch(_){}}
      const meta=row.querySelector('[data-item-meta]');
       if(giftSet.has(Number(item.variant_id))&&item.properties&&item.properties._mus_elaiza_gift===giftTag&&Number(item.final_line_price)===0){
         row.classList.add('mus-basket__item--gift');
         addText(meta,'FREE GIFT · £0.00','mus-basket__meta mus-basket__gift-label');
       }if(item.variant_title&&item.variant_title!=='Default Title')addText(meta,item.variant_title);if(item.selling_plan_allocation?.selling_plan?.name)addText(meta,item.selling_plan_allocation.selling_plan.name);Object.entries(item.properties||{}).forEach(([k,v])=>{if(!k.startsWith('_')&&v!=null&&v!=='')addText(meta,k+': '+String(v));});
      const base=Number(item.final_line_price ?? item.line_price)||0,shown=model.lines[index];row.querySelector('[data-item-price]').textContent=money(shown);if(shown<base){const s=row.querySelector('[data-item-original]');s.textContent=money(base);s.hidden=false;addText(row.querySelector('[data-item-discounts]'),tradeLabel()+' (estimated)','mus-basket__meta mus-basket__trade-line');}
      allocs(item).forEach(d=>{if(!(d.amount>0)||isElaizaGiftDiscountTitle(d.title))return;const label=isTradeTitle(d.title)?tradeLabel():d.title;addText(row.querySelector('[data-item-discounts]'),label+' (−'+money(d.amount)+')',isTradeTitle(d.title)?'mus-basket__meta mus-basket__trade-line':'mus-basket__meta');totals.set(label,(totals.get(label)||0)+d.amount);});
      const q=row.querySelector('[data-mus-basket-quantity]');q.value=String(item.quantity);q.dataset.current=String(item.quantity);q.setAttribute('aria-label','Quantity: '+title);row.querySelector('[data-mus-basket-adjust="-1"]').setAttribute('aria-label','Decrease quantity: '+title);row.querySelector('[data-mus-basket-adjust="1"]').setAttribute('aria-label','Increase quantity: '+title);row.querySelector('[data-mus-basket-remove]').setAttribute('aria-label','Remove: '+title);frag.appendChild(row);
    });
    list.replaceChildren(frag);totals.forEach((value,title)=>discountRow(summaryDiscounts,title,value,isTradeTitle(title)||title===tradeLabel()));(cart.cart_level_discount_applications||[]).forEach(d=>{const title=isTradeTitle(d.title)?tradeLabel():(d.title||'Discount');discountRow(summaryDiscounts,title,Number(d.total_allocated_amount)||0,isTradeTitle(d.title));});if(model.estimated)discountRow(summaryDiscounts,tradeLabel()+' (estimated)',model.savings,true);
    content.dataset.count=String(cart.item_count);root.querySelector('[data-mus-basket-empty]').hidden=cart.item_count!==0;root.querySelector('[data-mus-basket-summary]').hidden=cart.item_count===0;root.querySelector('[data-mus-basket-total]').textContent=money(model.total);root.querySelector('[data-mus-subtotal-label]').textContent=model.estimated?'Estimated subtotal':'Subtotal';root.querySelector('[data-mus-estimate-note]').hidden=!model.estimated;syncBadge(cart.item_count);renderRewards(cart);synced=true;setBusy(busy);updateUpsell(cart);
  }

  async function refresh(){const cart=await readCart();render(await syncDrawerGifts(cart));}
  async function inspect(source){open(source);if(busy)return;synced=false;showError();say(root.dataset.loading);setBusy(true);try{await refresh();say();}catch(e){showError(root.dataset.refreshError);say();}finally{setBusy(false);}}
  async function mutate(kind,body,source){if(busy)return;open(source);synced=false;showError();say(kind==='add'?root.dataset.adding:root.dataset.updating);setBusy(true);try{const options={method:'POST'};if(body instanceof FormData){body.delete('sections');body.delete('sections_url');body.delete('return_to');options.body=body;}else{options.headers={'Content-Type':'application/json'};options.body=JSON.stringify(body);}await request(root.dataset[kind==='add'?'addUrl':'changeUrl'],options);await refresh();say(kind==='add'?root.dataset.added:root.dataset.updated);document.dispatchEvent(new CustomEvent('mus:cart-updated',{detail:{itemCount:Number(content.dataset.count)}}));}catch(e){showError(e.message||root.dataset.error);try{await refresh();}catch(_){}say();}finally{setBusy(false);}}

  dialog.addEventListener('click',e=>{if(e.target.closest('[data-mus-basket-close]')){close();return;}if(e.target.closest('[data-mus-basket-retry]')){inspect(opener);return;}const upsell=e.target.closest('[data-mus-upsell-add]');if(upsell){e.preventDefault();if(busy||!synced)return;const variantId=Number(upsell.dataset.variantId);if(variantId)mutate('add',{items:[{id:variantId,quantity:1}]},upsell);return;}const action=e.target.closest('[data-mus-basket-adjust],[data-mus-basket-remove]');if(!action||busy||!synced)return;const row=action.closest('[data-mus-basket-key]'),input=row.querySelector('[data-mus-basket-quantity]'),qty=action.hasAttribute('data-mus-basket-remove')?0:Math.max(0,Number(input.dataset.current)+Number(action.dataset.musBasketAdjust));mutate('change',{id:row.dataset.musBasketKey,quantity:qty},action);});
  dialog.addEventListener('change',e=>{const input=e.target.closest('[data-mus-basket-quantity]');if(!input||busy||!synced)return;if(!/^\d+$/.test(input.value)){input.value=input.dataset.current;showError(root.dataset.invalidQuantity);return;}const q=Number(input.value);if(q!==Number(input.dataset.current))mutate('change',{id:input.closest('[data-mus-basket-key]').dataset.musBasketKey,quantity:q},input);});
  dialog.addEventListener('submit',e=>{if(!e.target.matches('[data-mus-basket-checkout-form]'))return;if(busy||!synced||Number(content.dataset.count)<1)e.preventDefault();});

  // A single capture handler owns basket navigation across every page.
  window.addEventListener('click',e=>{
    if(e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    const target=e.target instanceof Element?e.target:null;
    if(!target)return;
    const trigger=target.closest('[data-mus-open-cart]');
    if(trigger){e.preventDefault();e.stopImmediatePropagation();inspect(trigger);return;}
    const link=target.closest('a[href]');
    if(!link||root.contains(link)||link.hasAttribute('download')||link.getAttribute('target')==='_blank'||link.closest('.shopify-payment-button'))return;
    const u=sameUrl(link.getAttribute('href'));
    if(!u)return;
    const isCartLink=u.pathname.replace(/\/$/,'')===root.dataset.cartUrl.replace(/\/$/,'');
    if(isCartLink&&!u.searchParams.has('checkout')){
      e.preventDefault();e.stopImmediatePropagation();inspect(link);
    }else if(!e.defaultPrevented&&/\/cart\/add\/?$/.test(u.pathname)&&u.searchParams.has('id')){
      e.preventDefault();e.stopImmediatePropagation();
      const data=new FormData();u.searchParams.forEach((v,k)=>data.append(k,v));
      if(!data.has('quantity'))data.set('quantity','1');
      mutate('add',data,link);
    }
  },true);
  document.addEventListener('submit',e=>{if(e.defaultPrevented)return;const form=e.target;if(!(form instanceof HTMLFormElement)||!form.matches(formSelector))return;const source=e.submitter||form.querySelector('[name="add"],[type="submit"]'),u=sameUrl(source?.getAttribute('formaction')||form.action);if(!u||!/\/cart\/add\/?$/.test(u.pathname)||source?.name==='checkout'||source?.closest('.shopify-payment-button,.mus-dynamic-checkout'))return;const data=new FormData(form);if(!data.get('id'))return;e.preventDefault();e.stopImmediatePropagation();if(!data.has('quantity'))data.set('quantity','1');mutate('add',data,source);},true);
  window.addEventListener('pageshow',()=>{if(dialog.open&&!busy)inspect(opener);});
  document.querySelectorAll(navSelector).forEach(trigger=>{
    const u=trigger.hasAttribute('href')?sameUrl(trigger.getAttribute('href')):null;
    if(trigger.hasAttribute('data-mus-open-cart')||(u&&u.pathname.replace(/\/$/,'')===root.dataset.cartUrl.replace(/\/$/,''))){
      trigger.setAttribute('aria-haspopup','dialog');trigger.setAttribute('aria-controls','MusBasketDialog');
    }
  });
  setBusy(false);window.MusBasketDrawerV22={open:inspect};window.MusBasketDrawer=window.MusBasketDrawerV22;
  document.addEventListener('mus:open-cart',event=>{if(!dialog.open||!synced)inspect(event.detail?.source||null);});
  document.addEventListener('mus:external-cart-update',event=>{if(!busy)inspect(event.detail?.source||null);});
  if(root.dataset.pageType==='cart')inspect(document.querySelector('[data-mus-cart-landing] [data-mus-open-cart]'));
})();
